export const pawelRadziejewski = {
    'meta': {
        'title': 'Psychiatra dziecięcy Paweł Radziejewski • Centrum COLLIGO',
        'description': 'Jestem lekarzem specjalistą psychiatrii dzieci i młodzieży i dorosłych. Posiadam wieloletnie doświadczenie w pracy na oddziałach szpitalnych.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-dzieci-i-mlodziezy-pawel-radziejewski/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/pawel-radziejewski.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra Dzieci i Młodzieży Paweł Radziejewski'
        }
    }
}